import * as Eq from 'fp-ts/Eq';
import { pipe } from 'fp-ts/function';
import { JsonRecord } from 'fp-ts/Json';
import * as C from 'io-ts/Codec';
import { UniqueArray } from 'src/io/combinators/UniqueArray';
import { ProjectListColumn, ProjectListColumnKey } from 'src/modules/project-list/types/ProjectListColumn';

const PROJECT_LIST_COLUMN_KEY: C.Codec<unknown, string, ProjectListColumnKey> = C.literal(
  ProjectListColumnKey.MEMBERS,
  ProjectListColumnKey.STATUS,
  ProjectListColumnKey.UPDATED,
  ProjectListColumnKey.BEP,
  ProjectListColumnKey.ROI,
  ProjectListColumnKey.ROI_2,
  ProjectListColumnKey.ROI_5,
);

const PROJECT_LIST_COLUMN: C.Codec<unknown, JsonRecord, ProjectListColumn> = C.struct({
  key: PROJECT_LIST_COLUMN_KEY,
  enabled: C.boolean,
});

const PROJECT_LIST_COLUMN_EQ: Eq.Eq<ProjectListColumn> = pipe(
  Eq.eqStrict,
  Eq.contramap((it) => it.key),
);

export const PROJECT_LIST_COLUMN_LIST = UniqueArray(
  PROJECT_LIST_COLUMN,
  PROJECT_LIST_COLUMN_EQ,
);
